module.exports = __webpack_public_path__ + "img/neu-logo.05b25d10.png";